import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginIndex from './Auth';
import HomeIndex from './Home';
import DashboardIndex from './Home/Dashboard';
import UsersIndex from './Home/SystemUser';
import PatientsIndex from './Home/SystemPatient';
import SettingsIndex from './Home/Settings';
import SetDayLimit from './Home/Settings/components/SetDayLimit';
import SetDoctors from './Home/Settings/components/SetDoctors';
import SetStatuses from './Home/Settings/components/SetStatuses';
import SetTypes from './Home/Settings/components/SetTypes';
import SetMessageSettings from './Home/Settings/components/SetMessageSettings';
import SetBanks from './Home/Settings/components/SetBanks';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route exact path={'/'} element={<LoginIndex />}></Route>
        <Route path="/dashboard" element={<HomeIndex />}>
          <Route path="" element={<DashboardIndex />} />
          <Route path="users" element={<UsersIndex />} />
          <Route path="patients" element={<PatientsIndex />} />
          <Route path="setting" element={<SettingsIndex />}>
            <Route path="times" element={<SetDayLimit />} />
            <Route path="message" element={<SetMessageSettings />} />
            <Route path="bank" element={<SetBanks />} />
            <Route path="doctors" element={<SetDoctors />} />
            <Route path="types" element={<SetTypes />} />
            <Route path="statuses" element={<SetStatuses />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate replace to="/" />} />
     </Routes>
   </Router>
  );
}